export const RESEND_RESETPW_CODE_REQUESTING = 'RESEND_RESETPW_CODE_REQUESTING'
export const RESEND_RESETPW_CODE_SUCCESS = 'RESEND_RESETPW_CODE_SUCCESS'
export const RESEND_RESETPW_CODE_ERROR = 'RESEND_RESETPW_CODE_ERROR'
export const RESEND_RESETPW_CODE_URL = '/api/v1/users/reset_passwd_request'


// WEBPACK FOOTER //
// ./src/views/Pages/ResendResetPwCode/constants.js